import { css, html, LitEntity, SirenActionMixin } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './bin-path-name';
import './bin-profile';
import './bin-levels-admin-list-item';

class BinLevelsAdminList extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.bins = [];
  }

  static get properties() {
    return {
      bins: { type: Array, attribute: false },
      printMode: { type: Boolean, attribute: 'print-mode', reflect: true },
      showGraphToolbars: { type: Boolean, attribute: 'show-graph-toolbars' },
      showRaw: { type: Boolean, attribute: 'show-raw' },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
        max-width: 100%;
        position: relative;
      }
      p {
        text-align: center;
        color: var(--gray-80);
      }
      .list {
        display: flex;
        flex-direction: column;
      }
      .error-message {
        display: none;
        background-color: var(--red-20);
        padding: var(--root-margin);
        color: white;
      }
      @media print {
        :host(:not([print-mode])) .error-message {
          display: block;
        }
        /* Flex display breaks page-break css attributes */
        .list {
          display: block;
        }
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }

    if (!this.bins || this.bins.length === 0) {
      return html`<p>No Bins In This Organization</p>`;
    }

    return html`
      <div class="error-message">
        <h1>You have not entered print mode on this page!</h1>
        <p>Close this dialog and click the <b>Enter Print Mode</b> button before attempting to print</p>
      </div>

      <div class="list">
        ${this.bins.map((bin) => html`
          <bin-levels-admin-list-item
            .href="${bin.href}"
            ?print-mode="${this.printMode}"
            ?show-graph-toolbar="${this.showGraphToolbars}"
            ?show-raw="${this.showRaw}"
          ></bin-levels-admin-list-item>
        `)}
      </div>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.bins = [];
    if (!this.entity) {
      return;
    }
    this._parseBins(this.entity);
  }

  _parseBins(entity) {
    if (!entity || !entity.entities) {
      return;
    }

    const bins = entity.entities.map((sub) =>
      ({ href: sub.getLinkByRel('self').href, name: sub.properties.name }),
    );
    this.bins = [...this.bins, ...bins];
  }
}

window.customElements.define('bin-levels-admin-list', BinLevelsAdminList);
